/* src/app/home/partials/accounts-orders-stats-row/accounts-orders-stats-row.component.scss */
.statsRow {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.statTile {
  flex: 1 1 12rem;
  display: flex;
  align-items: center;
  gap: 0.9rem;
  background: #fff;
  border-radius: 0.6rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);
  padding: 1rem 1.25rem;
}
.statIcon {
  flex: 0 0 auto;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}
.statValue {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.1;
}
.statLabel {
  font-size: 0.78rem;
  color: #64748b;
  margin-top: 0.15rem;
}
/*# sourceMappingURL=accounts-orders-stats-row.component.css.map */
